import './styles.scss'

import React, { useState, useEffect, useCallback } from 'react'
import { useValues } from 'kea'
import PropTypes from 'prop-types'
import NProgress from 'nprogress'
import ReactHtmlParser from 'react-html-parser'

import FloatingField from 'lib/forms/floating-field'
import I18n from 'lib/i18n'

import controller from '~/scenes/search/controller.rb'

import logic from './logic'

const NotFound = ({ bounds }) => {
  const { filter } = useValues(logic)

  const [submitted, setSubmitted] = useState(false)
  const [submitting, setSubmitting] = useState(false)

  const [touched, setTouched] = useState(false)
  const [errors, setErrors] = useState({})

  const [formValues, setFormValues] = useState({
    activity: filter.query || '',
    email: '',
    phone: '',
    location: filter.location || ''
  })

  const validate = (values = formValues) => {
    const newErrors = {}

    if (!values.activity) {
      newErrors.activity = I18n.t('errors.messages.blank')
    }
    if (!values.location) {
      newErrors.location = I18n.t('errors.messages.blank')
    }
    if (!values.email || !values.email.includes('@')) {
      newErrors.email = I18n.t('errors.messages.blank')
    }
    if (!values.phone) {
      newErrors.phone = I18n.t('errors.messages.blank')
    }

    setErrors(newErrors)
    return !Object.keys(newErrors).length > 0
  }

  useEffect(() => {
    setFormValues(prev => {
      const updated = { ...prev, activity: filter.query || '' }
      validate(updated)
      return updated
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter.query])

  const updateField = useCallback((field, value) => {
    setFormValues(prevValues => {
      const newValues = { ...prevValues, [field]: value }

      validate(newValues)
      return newValues
    })
  }, [])
  const handleSubmit = async event => {
    event.preventDefault()
    setTouched(true)

    if (!validate()) return

    setSubmitting(true)
    NProgress.start()

    try {
      const result = await controller.sendNotFoundForm({
        category: formValues.activity,
        email: formValues.email,
        phone: formValues.phone,
        location: formValues.location,
        neLat: bounds ? bounds[0][0] : null,
        neLng: bounds ? bounds[0][1] : null,
        swLat: bounds ? bounds[1][0] : null,
        swLng: bounds ? bounds[1][1] : null
      })

      if (result.success) {
        setSubmitted(true)
      }
    } catch (error) {
      console.error(error)
    } finally {
      setSubmitting(false)
      NProgress.done()
    }
  }
  return (
    <div className='no-results-found'>
      <h1>{I18n.t('react.search.not_found.header')}</h1>
      <div className='owl' />
      <div className='text-with-owl'>
        <p>{I18n.t('react.search.not_found.line_1')}</p>
        <p>
          {ReactHtmlParser(
            I18n.t('react.search.not_found.recruit', {
              link: `<a href='/courses/new'>${I18n.t('react.search.not_found.recruit_link')}</a>`
            })
          )}
        </p>
        <h2>{submitted ? I18n.t('react.search.not_found.thanks_1') : I18n.t('react.search.not_found.cta')}</h2>
        {submitted ? <p>{I18n.t('react.search.not_found.thanks_2')}</p> : null}
      </div>

      {!submitted && (
        <form onSubmit={handleSubmit}>
          <FloatingField
            input={{ value: formValues.activity, onChange: event => updateField('activity', event.target.value) }}
            placeholder={I18n.t('react.search.not_found.field_activity')}
            maxLength={50}
            meta={{ touched, error: errors.activity }}
          />

          <FloatingField
            input={{ value: formValues.location, onChange: event => updateField('location', event.target.value) }}
            placeholder={I18n.t('react.search.not_found.field_location')}
            maxLength={100}
            meta={{ touched, error: errors.location }}
          />

          <FloatingField
            input={{ value: formValues.email, onChange: event => updateField('email', event.target.value) }}
            placeholder={I18n.t('react.search.not_found.field_email')}
            maxLength={100}
            meta={{ touched, error: errors.email }}
          />

          <FloatingField
            input={{ value: formValues.phone, onChange: event => updateField('phone', event.target.value) }}
            placeholder={I18n.t('react.search.not_found.field_phone')}
            maxLength={100}
            meta={{ touched, error: errors.phone }}
          />

          <button type='submit' disabled={submitting}>
            {I18n.t('react.search.not_found.button')}
          </button>
        </form>
      )}
    </div>
  )
}

NotFound.propTypes = {
  bounds: PropTypes.array
}

export default NotFound
